/** Public site origin for absolute links (share, deep-link to freemusiers). */
export const FREEMUSIERS_PUBLIC =
  (
    (import.meta.env.VITE_FREEMUSIERS_PUBLIC || import.meta.env.VITE_BANCAMP_PUBLIC) as
      | string
      | undefined
  )?.replace(/\/$/, '') || 'https://freemusiers.com';

/** Deprecated alias for backwards compatibility */
export const BANCAMP_PUBLIC = FREEMUSIERS_PUBLIC;

/**
 * Same-origin relative base for API/music in prod (nginx on games.freemusiers.com
 * proxies /api + /music). Dev uses Vite proxy to VITE_FREEMUSIERS_UPSTREAM.
 */
export const API_BASE = '';

export const APP_NAME = 'FREEMUSIERS GAMES';
